/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VIPRDataPoint'
], function(_, VIPRDataPoint) {

	// implements IDataPointIterator
	class VIPRDataPointIterator {
		constructor(dataset, context) {
			this.dataPointIndex = -1;
			this.queryResult = dataset.queryResult;
			this.dataset = dataset;
			this.dataItemInfo = this._getDataItemInfo();

			//viprDataPoints is a map that matches the lifecycle of the VIPRDataset.  
			//It stores backing datapoint objects that the vipr IDataPoint objects use for their API.
			//This is needed to support decorating the IDataPoints.
			this.viprDataPoints = this.dataset.viprDataPoints;

			this.context = context;

		}

		nextValue() {
			if (++this.dataPointIndex < this.queryResult.getRowCount()) {
				let thisdatapoint = this.viprDataPoints[this.dataPointIndex];
				//No IDatapoint exists for this key yet....create an object and create the API with asIDataPoint.
				if (!thisdatapoint) {
					thisdatapoint = new VIPRDataPoint(this.dataPointIndex, this.dataset, this.dataItemInfo, this.context);
					this.viprDataPoints[this.dataPointIndex] = thisdatapoint;
				}
				return thisdatapoint;
			}
			return null;
		}

		getTupleItems() {
			return this.viprDataPoints[this.dataPointIndex].getTupleItems();
		}

		//Cache information about the dataItems to avoid
		_getDataItemInfo() {
			const dataItemInfo = {
				isLatLong: {},
				formatter: {}
			};

			this.dataset.dataItems.forEach((dataItem, resultItemIndex) => {
				const slotDef = this.dataset.slots[resultItemIndex] && this.dataset.slots[resultItemIndex].getDefinition();
				const subType = slotDef && slotDef.getSubType();
				if (subType === 'longitude' || subType === 'latitude') {
					dataItemInfo.isLatLong[resultItemIndex]=true;
				}
				if (dataItem.getFormatter) {
					dataItemInfo.formatter[resultItemIndex] = dataItem.getFormatter && dataItem.getFormatter();
				}
			});

			return dataItemInfo;
		}
	}

	return VIPRDataPointIterator;
});
